import React, { useState } from "react";
import {
	Box,
	Boxed,
	Divider,
	Grid,
	IconChevronDownRegular,
	IconChevronUpRegular,
	Inline,
	skinVars,
	Text2,
	Touchable,
} from "@telefonica/mistica";
import { observer } from "mobx-react-lite";

interface IProps {
	title: string;
	children: React.ReactNode;
	analytic?: VoidFunction;
}

export const CollapsibleContentUp: React.FC<IProps> = observer((props) => {
	const { children, title, analytic } = props;
	const [open, setOpen] = useState(false);

	if (open && analytic) {
		analytic();
	}

	return (
		<Boxed>
			{open && (
				<>
					<Box paddingX={16} paddingTop={16}>
						{children}
					</Box>
					<Box paddingTop={16} paddingX={16}>
						<Divider />
					</Box>
				</>
			)}
			<Touchable onPress={() => setOpen(!open)}>
				<Grid justifyContent="center">
					<Box padding={16}>
						<Inline space={8}>
							<Text2 medium color={skinVars.colors.brand}>
								{title}
							</Text2>
							{open ? (
								<IconChevronUpRegular color={skinVars.colors.brand} size={20} />
							) : (
								<IconChevronDownRegular color={skinVars.colors.brand} size={20} />
							)}
						</Inline>
					</Box>
				</Grid>
			</Touchable>
		</Boxed>
	);
});
